module.exports = __webpack_public_path__ + "static/media/menu1_cont_06.b72854f9.png";